import api from './client'

export interface PlanTemplate {
  id: number
  name: string
  duration_type: string
  description: string | null
  is_active: boolean
}

export interface StudentPlanListItem {
  id: number
  student_id: number
  student_name: string | null
  tutor_id: number
  source_template_id: number | null
  template_name: string | null
  name: string
  status: string
  create_datetime: string | null
}

export interface PaginatedStudentPlans {
  items: StudentPlanListItem[]
  total: number
  page: number
  per_page: number
  total_pages: number
}

export interface StudentOption {
  id: number
  user_name: string
  email: string
}

export interface PlanActivityItem {
  id: number
  activity_type: string
  mastery_id: number | null
  is_vocabulary: boolean
  title: string
  description: string | null
  display_order: number
  status: string
}

export interface PlanSessionDetail {
  id: number
  title: string
  description: string | null
  display_order: number
  status: string
  activities: PlanActivityItem[]
}

export interface StudentPlanMeta {
  id: number
  student_id: number
  tutor_id: number
  name: string
  status: string
}

export const plansApi = {
  listPlans: (page = 1, perPage = 15) =>
    api.get<PaginatedStudentPlans>('/plans/list', { params: { page, per_page: perPage } }),

  getStudentsWithoutPlan: () =>
    api.get<StudentOption[]>('/plans/students/no-plan'),

  getTemplates: () =>
    api.get<PlanTemplate[]>('/plans/templates'),

  createPlan: (data: { name: string; student_id: number; template_id: number }) =>
    api.post('/plans/', data),

  getPlanSessions: (planId: number) =>
    api.get<PlanSessionDetail[]>(`/plans/${planId}/sessions`),

  assignSession: (sessionId: number) =>
    api.post<{ message: string; assignment_ids: number[] }>(`/plans/sessions/${sessionId}/assign`),

  assignAllSessions: (planId: number) =>
    api.post<{ message: string; assignment_ids: number[] }>(`/plans/${planId}/sessions/assign-all`),

  deletePlan: (planId: number) =>
    api.delete<{ message: string }>(`/plans/${planId}`),

  getPlanMeta: (planId: number) =>
    api.get<StudentPlanMeta>(`/plans/${planId}/meta`),

  insertSession: (
    planId: number,
    data: {
      position: number
      title: string
      description?: string | null
      status?: 'pending' | 'assigned'
    },
  ) =>
    api.post<{ message: string; id: number; display_order: number; status: string }>(
      `/plans/${planId}/sessions`,
      data,
    ),
}
